export default "__VITE_ASSET__D8Mr$4di__"